import React from 'react';
import { useListingPageContext } from '../context/ListingPageContext';
import SectionSchoolHero from './SectionSchoolHero/SectionSchoolHero';

import css from '../ListingPage.module.css';

function RenderSchool() {
  const { isMobileLayout, intl, viewport } = useListingPageContext();
  return (
    <div className={css.pageRoot}>
      <SectionSchoolHero isMobileLayout={isMobileLayout} intl={intl} viewport={viewport} />
    </div>
  );
}

export default RenderSchool;
